import script from "./Legend.vue?vue&type=script&setup=true&lang=ts"
export * from "./Legend.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__